module.exports = __webpack_public_path__ + "img/timeline-light.c64919e7.png";